exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge-member[data-v-06fc8337] {\n    margin: 0px 5px;\n    font-size: 1em;\n}\n", ""]);

// exports
